<div class="email-application  overflow-hidden">
  <div #contentOverlay class="app-content-overlay" [ngClass]="{show: isContentOverlay}" (click)="onContentOverlay()">
  </div>
  <div #emailSidebar class="email-app-sidebar d-xl-block" [ngClass]="{show: isEmailSidebarShow}">
    <span class="sidebar-close-icon d-xl-none" (click)="isContentOverlay = false; isEmailSidebarShow = false;">
      <i class="ft-x"></i>
    </span>
    <div [perfectScrollbar] class="email-app-sidebar-content">
      <div class="email-app-menu">
        <div class="form-group form-group-compose text-center mb-0">
          <button type="button" class="btn btn-danger btn-block mb-2 mt-1" (click)="compose(true)">
            <i class="ft-mail mr-2"></i> Compose</button>
        </div>
        <hr class="m-0">
        <span class="grey my-2 d-block font-small-3 text-uppercase">Messages</span>
        <div class="list-group list-group-messages">
          <a class="list-group-item list-group-item-action border-0" [ngClass]="{'active': activeTypeButton == 'Inbox'}"
            (click)="GetEmailsByType('Inbox')">
            <i class="ft-inbox mr-2"></i> <span>Inbox</span>
            <span class="badge bg-light-secondary badge-pill float-right">8</span>
          </a>
          <a class="list-group-item list-group-item-action border-0" [ngClass]="{'active': activeTypeButton == 'Sent'}"
            (click)="GetEmailsByType('Sent')">
            <i class="ft-send mr-2"></i> <span>Sent</span></a>
          <a class="list-group-item list-group-item-action border-0" [ngClass]="{'active': activeTypeButton == 'Draft'}"
            (click)="GetEmailsByType('Draft')">
            <i class="ft-file mr-2"></i> <span>Draft</span></a>
          <a class="list-group-item list-group-item-action border-0"
            [ngClass]="{'active': activeTypeButton == 'Starred'}" (click)="GetStarredEmails()">
            <i class="ft-star mr-2"></i> <span>Starred</span>
            <span class="badge bg-light-danger badge-pill float-right">3</span>
          </a>
          <a class="list-group-item list-group-item-action border-0 m-0"
            [ngClass]="{'active': activeTypeButton == 'Trash'}" (click)="GetEmailsByType('Trash')">
            <i class="ft-trash-2 mr-2"></i> <span>Trash</span></a>
        </div>
        <hr class="my-2">
        <span class="grey my-2 d-block font-small-3 text-uppercase">Labels</span>
        <div class="list-group list-group-messages border-0">
          <a class="list-group-item list-group-item-action border-0 d-flex justify-content-between"
            [ngClass]="{'active': activeTypeButton == 'Work'}" (click)="GetEmailsByLabel('Work')">
            <div class="d-flex align-items-center"><i class="ft-circle warning font-small-1 mr-2"></i><span>Work</span>
            </div>
            <span class="badge bg-light-warning badge-pill float-right">5</span>
          </a>
          <a class="list-group-item list-group-item-action border-0 d-flex align-items-center"
            [ngClass]="{'active': activeTypeButton == 'Family'}" (click)="GetEmailsByLabel('Family')">
            <i class="ft-circle danger font-small-1 mr-2"></i><span>Family</span></a>
          <a class="list-group-item list-group-item-action border-0 d-flex align-items-center"
            [ngClass]="{'active': activeTypeButton == 'Friends'}" (click)="GetEmailsByLabel('Friends')">
            <i class="ft-circle primary font-small-1 mr-2"></i><span>Friends</span></a>
          <a class="list-group-item list-group-item-action border-0 d-flex justify-content-between"
            [ngClass]="{'active': activeTypeButton == 'Private'}" (click)="GetEmailsByLabel('Private')">
            <div class="d-flex align-items-center"><i
                class="ft-circle success font-small-1 mr-2"></i><span>Private</span></div>
            <span class="badge bg-light-success badge-pill float-right">3</span>
          </a>
        </div>
      </div>
    </div>
  </div>
  <div class="email-app-content row">
    <div class="email-search-box w-100 p-2">
      <div class="media px-2 d-flex align-items-center">
        <span class="email-app-sidebar-toggle ft-menu cursor-pointer font-large-1 mr-3 d-xl-none"
          (click)="onSidebarToggle()"></span>
        <div class="media-body pr-1">
          <input type="text" class="form-control" placeholder="Search for emails" [(ngModel)]="searchQuery">
        </div>
      </div>
    </div>
    <div class="email-app-content-area w-100">
      <div class="email-app-list-mails p-0" (click)="onListItemClick()">
        <div [perfectScrollbar] class="email-app-list">
          <div id="users-list">
            <div class="list-group">
              <div class="users-list-padding">
                <a class="list-group-item list-group-item-action"
                  [ngClass]="{'selected-email': mail.mailId == selectedMailId, 'border-0': mail.mailId != selectedMailId}"
                  *ngFor="let mail of mail | search:'mailFrom,subject,body':searchQuery"
                  (click)="DisplayMessage([mail.mailId])">
                  <div class="media email-list-text p-0">
                    <span class="avatar {{mail.imageClass}} mr-2">
                      <span *ngIf="!mail.hasImage" class="avatar-content">{{
                        mail.imageText }}</span>
                      <img *ngIf="mail.hasImage" width="32" height="32" [src]="mail.imagePath" alt="avatar">
                    </span>
                    <div class="media-body">
                      <h6 class="list-group-item-heading">
                        <span> {{ mail.mailFrom }} </span>
                        <span class="float-right">
                          <i class="ft-paperclip mr-1" *ngIf="mail.hasAttachment"></i>
                          <span
                            [ngClass]="mail.isRead === false ? 'email-list-text font-small-2 email-time text-bold-400' : 'email-list-text font-small-2 email-time'">{{
                            mail.time }}</span>
                        </span>
                      </h6>
                      <p
                        [ngClass]="mail.isRead === false ? 'list-group-item-text text-truncate text-bold-500' : 'list-group-item-text text-truncate' ">{{
                        mail.subject }}</p>
                      <p class="list-group-item-text">{{ mail.body }}
                        <span class="float-right" *ngIf="mail.hasLabel">
                          <span class="badge mr-1 {{mail.labelClass}}">{{
                            mail.labelType }}</span>
                          <i *ngIf="isEmailImportant" class="font-medium-1 ft-star warning"></i>
                          <i *ngIf="!isEmailImportant" class="font-medium-1 ft-star"></i>
                          <!-- <i [ngClass]="mail.isImportant === false ? 'font-medium-1 ft-star blue-grey lighten-3' : 'font-medium-1 ft-star warning'"></i> -->
                        </span>
                        <span class="float-right primary" *ngIf="!mail.hasLabel">
                          <i class="font-medium-1 ft-star blue-grey lighten-3"></i>
                        </span>
                      </p>

                    </div>
                  </div>
                </a>
                <p class="primary text-center" *ngIf="mail.length === 0">There are no messages!</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="email-app-mail-content" #emailContent [ngClass]="{'show-email-content': isMessageSelected}">
        <div class="email-app-mail-content-detail px-4 py-3 py-md-1" [perfectScrollbar] *ngIf="isMessageSelected">
          <div class="email-app-options">
            <div class="row d-md-none">
              <button class="btn btn-primary ml-2 back-to-inbox mb-2" (click)="OnBackToInbox()">
                <i class="ft-chevron-left mr-2"></i> Back to inbox</button>
            </div>
            <div class="row">
              <div class="col-sm-6 col-12 text-left">
                <div class="btn-group" role="group" aria-label="Basic example">
                  <button type="button" class="btn btn-sm bg-light-secondary" data-toggle="tooltip" data-placement="top"
                    data-original-title="Replay">
                    <i class="ft-corner-up-left font-small-3"></i>
                  </button>
                  <button type="button" class="btn btn-sm bg-light-secondary" data-toggle="tooltip" data-placement="top"
                    data-original-title="Replay All">
                    <i class="ft-chevrons-left font-small-3"></i>
                  </button>
                  <button type="button" class="btn btn-sm bg-light-secondary" data-toggle="tooltip" data-placement="top"
                    data-original-title="Report SPAM">
                    <i class="ft-alert-octagon font-small-3"></i>
                  </button>
                  <button type="button" class="btn btn-sm bg-light-secondary" data-toggle="tooltip" data-placement="top"
                    data-original-title="Delete">
                    <i class="ft-trash-2 font-small-3"></i>
                  </button>
                </div>
              </div>
              <div class="col-sm-6 col-12 text-right">
                <div class="btn-group" role="group" aria-label="Basic example">
                  <button type="button" class="btn btn-sm bg-light-secondary" data-toggle="tooltip" data-placement="top"
                    data-original-title="Previous">
                    <i class="ft-chevron-left font-small-3"></i>
                  </button>
                  <button type="button" class="btn btn-sm bg-light-secondary" data-toggle="tooltip" data-placement="top"
                    data-original-title="Next">
                    <i class="ft-chevron-right font-small-3"></i>
                  </button>
                </div>
                <div class="btn-group ml-1">
                  <div ngbDropdown display="dynamic" [placement]="placement" class="d-inline-block">
                    <button class="btn btn-sm bg-light-secondary dropdown-toggle" id="dropdownBasic1"
                      ngbDropdownToggle>More</button>
                    <div ngbDropdownMenu aria-labelledby="dropdownBasic1">
                      <button class="dropdown-item" (click)="markAsUnread();">Mark as unread</button>
                      <button class="dropdown-item" *ngIf="!isEmailImportant" (click)="markAsImportant();">Mark
                        as important</button>
                      <button class="dropdown-item" *ngIf="isEmailImportant" (click)="markAsUnimportant();">Mark
                        as unimportant</button>
                      <button class="dropdown-item">Add star</button>
                      <button class="dropdown-item">Add to task</button>
                      <div class="dropdown-divider"></div>
                      <button class="dropdown-item">Filter mail</button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="email-app-title card-body px-0">
            <h3 class="list-group-item-heading">{{message.subject}}</h3>
            <p class="list-group-item-text">
              <span class="primary">
                <span class="badge bg-light-primary">Previous</span>
                <i *ngIf="isEmailImportant" class="float-right font-medium-3 ft-star warning"></i>
                <i *ngIf="!isEmailImportant" class="float-right font-medium-3 ft-star"></i>
              </span>
            </p>
          </div>

          <div *ngFor="let messageDetail of message.messages">
            <div id="headingCollapse2" class="card-header p-0">
              <a (click)="messageDetail.collapsed = !messageDetail.collapsed"
                [attr.aria-expanded]="!messageDetail.collapsed" [attr.aria-controls]="messageDetail.messageId"
                [ngClass]="{'collapsed': messageDetail.collapsed, 'opened-email': !messageDetail.collapsed}"
                class=" email-app-sender list-group-item list-group-item-action border-0 ">
                <div class="media">
                  <span class="avatar {{messageDetail.avatarClass}} mr-2">
                    <span *ngIf="!messageDetail.hasAvatar" class="avatar-content">{{
                        messageDetail.avatarText }}</span>
                    <img *ngIf="messageDetail.hasAvatar" width="32" height="32" alt="avatar"
                      [src]="messageDetail.avatarPath">
                  </span>
                  <div class="media-body">
                    <h6 class="list-group-item-heading">{{messageDetail.mailFrom}}</h6>
                    <p class="list-group-item-text  m-0">to {{messageDetail.mailTo}}
                      <span class="float-right text muted" *ngIf="messageDetail.collapsed">{{messageDetail.time}}</span>
                      <span class="float-right" *ngIf="!messageDetail.collapsed">
                        <i class="ft-corner-up-left mr-1"></i>
                        <i class="ft-arrow-right mr-1"></i>
                        <i class="ft-more-vertical-"></i>
                      </span>
                    </p>

                  </div>
                </div>
              </a>
            </div>
            <div [id]="messageDetail.messageId" [ngbCollapse]="messageDetail.collapsed">
              <div class="card-content">
                <div class="email-app-text card-body py-0">
                  <div class="email-app-message mt-2">
                    <div [innerHTML]="messageDetail.body">
                    </div>
                    <div *ngIf="messageDetail.hasAttachment">
                      <p class="primary">Attachments:</p>
                      <div *ngFor="let attachment of messageDetail.attachments" class="float-left mr-2">
                        <img class="media-object width-100" [src]="attachment.url" alt="Generic placeholder image">
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="email-app-text-action card-content">

            </div>
          </div>

        </div>
        <div class="email-app-mail-content-detail" *ngIf="!isMessageSelected">
          <p class="primary text-center">Select a message to read</p>
        </div>
      </div>
    </div>
  </div>
  <div class="compose-new-mail-sidebar" [ngClass]="{show: isComposeShow}">
    <span class="compose-sidebar-close-icon" (click)="compose(false)">
      <i class="ft-x"></i>
    </span>
    <div class="card bg-transparent shadow-none quill-wrapper m-0">
      <div class="card-header">
        <h3 class="card-title">New Message</h3>
      </div>
      <!-- form start -->
      <form action="#" id="compose-form">
        <div class="card-content">
          <div class="card-body">
            <div class="form-group">
              <label for="compose-email-from">from</label>
              <input type="text" id="compose-email-from" class="form-control" placeholder="user@example.com" disabled>
            </div>
            <div class="form-group">
              <label class="sr-only" for="compose-email-to">To</label>
              <input type="email" id="compose-email-to" class="form-control" placeholder="To" required>
            </div>
            <div class="form-group">
              <label class="sr-only" for="compose-email-subject">Subject</label>
              <input type="text" id="compose-email-subject" class="form-control" placeholder="Subject">
            </div>
            <div class="form-group">
              <label class="sr-only" for="compose-email-cc">CC</label>
              <input type="text" id="compose-email-cc" class="form-control" placeholder="CC">
            </div>
            <div class="form-group">
              <label class="sr-only" for="compose-email-bcc">BCC</label>
              <input type="text" id="compose-email-bcc" class="form-control" placeholder="BCC">
            </div>
            <!-- Compose mail Quill editor -->
            <div class="snow-container border rounded">

              <quill-editor customToolbarPosition="bottom" format="object">
                <div quill-editor-toolbar>
                  <span class="ql-formats">
                    <button class="ql-bold" [title]="'Bold'"></button>
                    <button class="ql-italic"></button>
                    <button class="ql-underline"></button>
                    <button class="ql-link"></button>
                    <button class="ql-image"></button>
                  </span>
                </div>
              </quill-editor>
            </div>
            <div class="form-group mt-2">
              <div class="custom-file">
                <input type="file" class="custom-file-input" id="compose-email-attach">
                <label class="custom-file-label" for="compose-email-attach">Attach file</label>
              </div>
            </div>
          </div>
        </div>
        <div class="card-footer d-flex justify-content-end pt-0">
          <button type="reset" class="btn bg-light-secondary compose-cancel-btn mr-2">
            <i class='ft-x m-0 mr-sm-1'></i>
            <span class="d-sm-inline-block d-none">Cancel</span>
          </button>
          <button type="submit" class="btn-send btn btn-primary">
            <i class='ft-send m-0 mr-sm-1'></i>
            <span class="d-sm-inline-block d-none">Send</span>
          </button>
        </div>
      </form>
      <!-- form start end-->
    </div>
  </div>
</div>
